<template>
  <div>
    <v-card style="width: 320px;">
      <v-card-title class="justify-center">Administrative Login</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          outlined
          hide-details
          class="mb-2"
          type="email"
          :disabled="loggingIn"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          outlined
          hide-details
          :disabled="loggingIn"
          @keydown="checkKeypress"
        ></v-text-field>
        <div class="text-right my-2">
          <!--<router-link :to="{name: 'forgot-password'}" style="text-decoration: none;">Forgot Password</router-link>-->
        </div>
        <div class="text-center mt-4">
          <v-btn color="primary" :loading="loggingIn" @click="login" :disabled="!email || !password">Log In</v-btn>
        </div>
      </v-card-text>
      <!--<v-divider class="mt-4" />
      <div class="orViaContainer">OR</div>
      <v-card-text class="text-center pt-2">
        <v-btn small depressed :disabled="loggingIn"><v-icon class="mr-1" small>mdi-microsoft-office</v-icon>Sign In With Office</v-btn>
      </v-card-text>-->
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AuthIndex',

  data: () => ({
    email: null,
    password: null,
    loggingIn: false
  }),
  methods: {
    login: function() {
      this.loggingIn = true;
      let params = {
        email: this.email,
        password: this.password
      }
      this.$http.post('auth', params)
        .then(response => {
          this.$store.dispatch('loginUser',response.data);
        })
        .catch(err => {
          this.$swal.fire('Error', err.response.data.message, 'error');
          this.loggingIn = false;
        });
    },
    checkKeypress: function(e) {
      if(e.key == 'Enter') this.login();
    }
  }
};
</script>

<style lang="scss">
  .orViaContainer {
    margin: -8px auto 0px auto;
    background-color: #FFF;
    width: 30px;
    font-size: 12px;
    text-align: center;
  }
</style>